import React, { Component } from 'react';
import { connect } from 'react-redux';
import Loader from 'react-loader';
import { getFormValues } from 'redux-form';
import {
  Button,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap';
import Layout from '../components/Layout';
import PageNav from '../components/PageNav';
import ServiceForm from '../modules/ServiceForm';
import { fetchServiceDetail } from '../modules/ServiceDetail/actions';
import {
  isLoaded,
  getError,
} from '../modules/ServiceDetail/selectors';
import { deleteService } from '../modules/ServiceList/actions';
import {SERVICE_FORM_NAME} from "../modules/ServiceForm/constants"

class EditServicePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false
    };

    this.toggle = this.toggle.bind(this);
  }

  componentDidMount() {
    const { id, lang } = this.props.match.params;
    this.props.fetchServiceDetail(id, lang);
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    });
  }

  deleteService = () => {
    const { id, lang } = this.props.match.params;
    this.props.deleteService(id, lang, () => {
      this.toggle();
      this.props.history.push('/sluzby');
    });
  };

  getConfig = () => {
    const { state } = this.props.location;
    if (!state) {
      return undefined;
    } else {
      return state;
    }
  };

  render() {
    const { isLoaded, serviceInitialValues, match } = this.props;
    const { lang } = match.params;

    const initialValues = { ...serviceInitialValues, lang };

    return (
      <Layout>
        <Container>
          <Loader loaded={isLoaded}>
            <PageNav>
              <h1>Upravit službu</h1>
              <Button onClick={this.toggle} color="danger">
                Smazat tuto mutaci
              </Button>
            </PageNav>
            <ServiceForm
              config={this.getConfig()}
              initialValues={initialValues}
            />
            <Modal
              isOpen={this.state.modal}
              toggle={this.toggle}
              className={this.props.className}
              backdrop={this.state.backdrop}
            >
              <ModalHeader toggle={this.toggle}>Smazat</ModalHeader>
              <ModalBody>Opravdu chcete tuto mutaci služby smazat?</ModalBody>
              <ModalFooter>
                <Button color="danger" onClick={this.deleteService}>
                  Smazat
                </Button>{' '}
                <Button color="secondary" onClick={this.toggle}>
                  Zrušit
                </Button>
              </ModalFooter>
            </Modal>
          </Loader>
        </Container>
      </Layout>
    );
  }
}

const mapStateToProps = state => {
  return {
    serviceInitialValues: getFormValues(SERVICE_FORM_NAME)(state),
    isLoaded: isLoaded(state),
    error: getError(state)
  };
};

export default connect(
  mapStateToProps,
  { fetchServiceDetail, deleteService }
)(EditServicePage);



// WEBPACK FOOTER //
// ./src/pages/EditServicePage.js